import React, { useState, useEffect } from "react";
import axios from "axios"; 
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom"; // Import Link from React Router

const API_URL = process.env.REACT_APP_API_URL_EC2;

const ProductGrid = () => {
  const [products, setProducts] = useState([]);
  const category = "clothing"; // Set category dynamically if needed

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        let response = await axios.post(`${API_URL}/api/getImages`, {
          category: category,
        });

        setProducts(response.data.data);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchProducts();
  }, []);

  return (
    <Container className="py-4">
      <Row>
        {products.map((product) => (
          <Col key={product._id} xs={12} sm={6} md={4} className="mb-4">
            <Card className="shadow-sm text-center h-100">
              <Card.Img
                variant="top"
                src={product.image}
                alt={product.title}
                style={{
                  height: "320px",
                  objectFit: "contain", // Ensure the entire image fits within the container
                  width: "100%",
                }}
              />
              <Card.Body>
                <Card.Title className="text-sm">{product.title}</Card.Title>
                <Card.Text className="text-muted">${product.price}</Card.Text>
                {/* Pass productId and category in the URL */}
                <Link to={`/product/${product._id}/${category}`}>
                  <Button variant="primary" size="sm">Explore</Button>
                </Link>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default ProductGrid;
